import { render, staticRenderFns } from "./dragpicturew.vue?vue&type=template&id=58045b4a&scoped=true"
import script from "./dragpicturew.vue?vue&type=script&lang=js"
export * from "./dragpicturew.vue?vue&type=script&lang=js"
import style0 from "./dragpicturew.vue?vue&type=style&index=0&id=58045b4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58045b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58045b4a')) {
      api.createRecord('58045b4a', component.options)
    } else {
      api.reload('58045b4a', component.options)
    }
    module.hot.accept("./dragpicturew.vue?vue&type=template&id=58045b4a&scoped=true", function () {
      api.rerender('58045b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/dragpicturew.vue"
export default component.exports